module.exports = __webpack_public_path__ + "static/media/productspot.71692654.png";